import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'core/elements';
import { FormProvider } from 'core/states';

import { AddVendorAssociationForm } from './AddVendorAssociationForm';
import { addVendorSchema } from './schema';

type IProps = {
  onSubmitSuccess: () => void;
  requireDefaultVendor?: boolean;
  manufacturerId?: string;
  manufacturerName?: string;
  button?: React.ReactNode;
};

export const AddVendorAssociation = ({
  onSubmitSuccess,
  requireDefaultVendor = false,
  manufacturerId,
  manufacturerName,
  button,
}: IProps) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { t } = useTranslation();

  const formDefaultValues = useMemo(
    () => ({
      manufacturer: manufacturerId ? { id: manufacturerId, name: manufacturerName } : null,
      vendorAssociations: [{ vendor: null, isDefault: false }],
    }),
    [manufacturerId, manufacturerName]
  );

  return (
    <>
      <Link
        onClick={() => {
          setIsFormOpen(true);
        }}
      >
        {button || `+ ${t('buttonLabelAddVendor')}`}
      </Link>
      <FormProvider
        schema={addVendorSchema(requireDefaultVendor)}
        defaultValues={formDefaultValues}
        resetDefaultValues
      >
        <AddVendorAssociationForm
          isFormOpen={isFormOpen}
          title={manufacturerId ? t('titleAddVendor') : t('titleAddManufacturer')}
          onClose={() => setIsFormOpen(false)}
          onSubmitSuccess={onSubmitSuccess}
          disabledFields={{
            manufacturer: !!manufacturerId,
          }}
        />
      </FormProvider>
    </>
  );
};
